import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from "../../utils";

export const getDownloads = createAsyncThunk(
    "downloads",
    async () => {
        const res = await apiFetch("api/haki/downloads");
        return await res.json();
    }
);

export const getPricing = createAsyncThunk(
    'pricing',
    async () => {
        const res = await apiFetch("api/haki/pricing");
        return await res.json();
    }
);

const publicSlice = createSlice({
    name: "public",
    initialState: {
        downloads: [],
        loading: false,
        error: false,
        pricing: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch user
            .addCase(getDownloads.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDownloads.fulfilled, (state, action) => {
                state.downloads = action.payload;
                state.loading = false;
            })
            .addCase(getDownloads.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getPricing.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPricing.fulfilled, (state,action) => {
                state.pricing = action.payload;
                state.loading = false;
            })
            .addCase(getPricing.rejected, (state,action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default publicSlice.reducer;
